import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

export interface User {
  id: string;
  username: string;
  email?: string;
  is_admin?: boolean;
  created_at?: string;
  updated_at?: string;
  collection_access?: CollectionAccess[];
}

export interface CollectionAccess {
  collection_id: string;
  collection_name: string;
  access_level: 'read' | 'write' | 'admin';
  granted_at: string;
}

export class UserService {
  static async getUsers(): Promise<User[]> {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(`${API_BASE_URL}/api/users`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.users;
  }

  static async addUser(user: { username: string; password: string; email?: string; is_admin?: boolean }): Promise<User> {
    const token = localStorage.getItem('authToken');
    const response = await axios.post(`${API_BASE_URL}/api/users`, user, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.user;
  }

  static async updateUser(id: string, user: { username?: string; password?: string; email?: string; is_admin?: boolean }): Promise<User> {
    const token = localStorage.getItem('authToken');
    const response = await axios.put(`${API_BASE_URL}/api/users/${id}`, user, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.user;
  }

  static async deleteUser(id: string): Promise<User> {
    const token = localStorage.getItem('authToken');
    const response = await axios.delete(`${API_BASE_URL}/api/users/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.user;
  }

  // Collection access management methods
  static async getUsersWithCollectionAccess(): Promise<User[]> {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(`${API_BASE_URL}/api/users/collection-access`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.users;
  }

  static async getUserCollectionAccess(userId: string): Promise<CollectionAccess[]> {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(`${API_BASE_URL}/api/users/${userId}/collections`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.access;
  }

  static async grantCollectionAccess(userId: string, collectionId: string, accessLevel: 'read' | 'write' | 'admin' = 'read'): Promise<CollectionAccess> {
    const token = localStorage.getItem('authToken');
    const response = await axios.post(`${API_BASE_URL}/api/users/${userId}/collections`, {
      collectionId,
      accessLevel
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.access;
  }

  static async revokeCollectionAccess(userId: string, collectionId: string): Promise<CollectionAccess> {
    const token = localStorage.getItem('authToken');
    const response = await axios.delete(`${API_BASE_URL}/api/users/${userId}/collections/${collectionId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.access;
  }
} 